<template>
    <div class="form-black">
        <img :src="'/images/cars-4free-3-v1.png'" :alt="`AutoBesikos Christmas`" width="685" height="358">
        <h2>Exclusive προσφορά από την AutoBesikos</h2>
        <p>Απόκτησε τώρα το μεταχειρισμένο σου αυτοκίνητο online.</p>
        <Button href="/vehicles" inline>Δες αυτοκίνητα</Button>
    </div>
</template>

<script>
    import Button from "../Button/Button.vue";

    export default {
        components: {
            Button,
        },
        props: {
            interestFor: String,
            page: String,
        },
        setup(props, { slots, attrs }) {
            return { };
        },
        data() {
            return {
            }
        },
        methods: {
        },
    }
</script>